import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Strings } from '../util/Strings';

export abstract class AbstractApiService {

    constructor(protected http: HttpClient) { }

    protected appUrl: string = environment.url.api;

    abstract get prefix(): string;

    protected prefixUrl(): string {
        return [this.appUrl, this.prefix].join("/");
    }

    protected url(path: string): string {
        if (Strings.isEmpty(path))
            return this.prefixUrl();
        else
            return [this.prefixUrl(), path].join("/");
    }

    protected post(url: string, body: any = null, options?: any): Observable<any> {
        if (options)
            return this.http.post(this.url(url), body, options).pipe();
        else
            return this.http.post(this.url(url), body).pipe();
    }

    protected get(url: string, options?: any): Observable<any> {
        if (options)
            return this.http.get(this.url(url), options).pipe();
        else
            return this.http.get(this.url(url)).pipe();
    }

    protected put(url: string, body: any = null, options?: any): Observable<any> {
        if (options)
            return this.http.put(this.url(url), body, options).pipe();
        else
            return this.http.put(this.url(url), body).pipe();
    }

    protected delete(url: string, options?: any): Observable<any> {
        if (options)
            return this.http.delete(this.url(url), options).pipe();
        else
            return this.http.delete(this.url(url)).pipe();
    }
}